import { ReactiveFormsModule, FormsModule } from '@angular/forms';

export const FORMS_IMPORTS = [
  FormsModule,
  ReactiveFormsModule
];